export const RADIUS = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 32,
  "2xl": 36,
};
